// Build information - available at runtime
export const BUILD_ID = import.meta.env.MODE === 'production' 
  ? (() => {
      // Try to load from build-info.json
      try {
        // This will be populated at build time
        return 'loading...';
      } catch {
        return 'dev-local';
      }
    })()
  : 'dev-local';

export const PROJECT_ID = import.meta.env.VITE_FB_PROJECT_ID || 'MISSING';
export const AUTH_DOMAIN = import.meta.env.VITE_FB_AUTH_DOMAIN || 'MISSING';
export const MODE = import.meta.env.MODE || 'development';

export const CURRENT_ORIGIN = typeof window !== 'undefined' 
  ? window.location.origin 
  : 'N/A';

export const CURRENT_HOST = typeof window !== 'undefined'
  ? window.location.host
  : 'N/A';


